import { Action, createReducer, on } from '@ngrx/store';
import { ILoginState } from './login';
import { LOGIN_RESET, LOGIN_SUCCESS } from './login.actions';

/* INITIAL STATE */
const initialState: ILoginState = {
  authToken: '',
};

const handleLogin = (
  state: ILoginState,
  { responseLogin }: { responseLogin: ILoginState }
): ILoginState => {
  return {
    ...state,
    ...responseLogin,
  };
};

const handleLoginReset = (): ILoginState => {
  return {
    authToken: '',
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(LOGIN_SUCCESS, handleLogin),
  on(LOGIN_RESET, handleLoginReset)
);

export const loginReducer = (
  state: ILoginState | undefined,
  action: Action
): ILoginState => reducer(state, action);
